import { Card } from '@tw/tw-component-library';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.secondary || '#666'};
  margin-bottom: 1rem;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const OptionTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const OptionDescription = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.secondary || '#666'};
`;

export interface WorkspaceTypeStepProps {
  workspaceData: {
    type?: 'client-matter' | 'non-client-matter';
  };
  onUpdate: (updates: {
    type: 'client-matter' | 'non-client-matter';
  }) => void;
}

export const WorkspaceTypeStep: React.FC<WorkspaceTypeStepProps> = ({
  workspaceData,
  onUpdate,
}) => {

  const handleOptionClick = (value: 'client-matter' | 'non-client-matter') => {
    onUpdate({ type: value });
  };

  const options = [
    {
      value: 'client-matter' as const,
      title: 'Client-Matter Workspace',
      description: 'Create a workspace for a specific client and matter',
    },
    {
      value: 'non-client-matter' as const,
      title: 'Non-Matter Workspace',
      description: 'Create a workspace for work unrelated to a client file',
    },
  ];

  return (
    <Container>
      <div>
        <Title>Select Workspace Type</Title>
        <Description>
          Choose the type of workspace you want to create
        </Description>
      </div>
      <OptionsContainer>
        {options.map((option) => (
          <Card
            key={option.value}
            data-tour={
              option.value === 'non-client-matter'
                ? 'create-ws-type-non-matter'
                : option.value === 'client-matter'
                  ? 'create-ws-type-client-matter'
                  : undefined
            }
            hover
            active={workspaceData.type === option.value}
            onClick={() => handleOptionClick(option.value)}
          >
            <OptionTitle>{option.title}</OptionTitle>
            <OptionDescription>{option.description}</OptionDescription>
          </Card>
        ))}
      </OptionsContainer>
    </Container>
  );
};
